<template>
    <div class="table-list lease-done">
        <alart-msg :display="alart.success" styleType="success" @alartStatus="alart.success = false">
            <span class="title" slot="title">{{msg.success}}</span>
        </alart-msg>
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.error}}</span>
        </alart-msg>
        <refund-detail :refundItem="listItem"></refund-detail>
        <ledger-detail :ledgerItem="listItem"></ledger-detail>
        <task-detail :taskSeq="taskSeq"></task-detail>
        <bill-detail :billId="billId" ></bill-detail>
        <div class="mask"></div>
        <div class="table-list-title">
            <span class="date">時間</span>
            <span class="house">房源名稱</span>
            <span class="address">地址</span>
            <span class="source">來源</span>
            <span class="income">收支</span>
            <span class="amount">總金額(已扣手續費)</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-show="filterByWord.length == 0 && incomeAndExpenditure.length != 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <button class="default-button" @click="setFilterDefault">清除篩選</button>
            </div>
            <div v-show="incomeAndExpenditure.length == 0" class="is-empty">0 筆資料</div>
            <ul>
                <li v-for="(list,index) in filterByWord" :key="index">
                    <span class="date">{{getFormatDate(list.transactionDate)}}</span>
                    <span class="house">{{list.houseName}}</span>
                    <span class="address">{{list.address}}</span>
                    <span class="source">
                        <span>{{transSource(list.source)}}</span>
                        <!-- <span v-if="list.note">{{list.note}}</span> -->
                    </span>
                    <span class="income">{{transType(list.type)}}</span>
                    <span v-if="list.type == 'INCOME'" class="amount blue">+ {{toCurrency(list.amountFormatString)}}</span>
                    <span v-else class="amount red">- {{toCurrency(list.amountFormatString)}}</span>
                    <span v-if="list.source == 'CONTRACT_BILL' || list.source == 'HOUSE_TASK_BONUS' || list.source == 'HOUSE_LEDGER' || list.source == 'RETURN_PAID_HOUSE_TASK_BONUS' || list.source == 'BOOKING_DEPOSIT_FOR_TENANT_REJECT' " class="action">
                        <dot-dropmenu>
                            <ul >
                                <li v-if="list.source == 'CONTRACT_BILL'" @click="setBillDetail(list.sourceCid)">帳單明細</li>
                                <li v-if="isReturnTaskBonus(list.source) || list.source == 'BOOKING_DEPOSIT_FOR_TENANT_REJECT'" @click="openDetail('refund', list),$analytics.logEvent('退款詳情', { screen_name: '退款詳情'})">查看詳情</li>
                                <li v-if="list.source == 'HOUSE_LEDGER'" @click="openDetail('ledger', list), $analytics.logEvent('記帳詳情', { screen_name: '記帳詳情'})">查看詳情</li>
                                <li v-if="list.source == 'HOUSE_TASK_BONUS'" @click="openDetail('taskDetail', list.referenceSeq), $analytics.logEvent('任務詳情', { screen_name: '任務詳情'})">查看詳情</li>
                                <!-- <li>刪除</li> -->
                            </ul>
                        </dot-dropmenu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import newBill from '@/components/widge/newBill.vue';
import BillDetail from '@/components/widge/BillDetail.vue';
import refundDetail from '@/components/widge/modal/refundDetail.vue';
import ledgerDetail from '@/components/widge/modal/ledgerDetail.vue';
import taskDetail from '@/components/widge/modal/taskDetail.vue';

import { mapGetters } from 'vuex'
export default {
    data () {
        return{
            filterEmpty: false,
            leaseDataEmpty: false,
            leaseDataError: false,
            isLoading: true,
            contractId: null,
            billId: null,
            listItem: {},
            taskSeq: null,
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                error: null,
            }
        }
    },
    mounted () {
        this.$store.dispatch('getIncomeAndExpenditureMgtList')
    },
    watch: {
        filterByWord:{
            handler: function (val) {
                this.$store.dispatch('setIncomeFilterResultTotal',  val.length)
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        setFilterDefault: function () {
            this.$store.dispatch('setIncomeFilterDefault')
        },
        openDetail: function (type, data) {
            this.listItem = data
            document.getElementsByClassName('financial-management-default')[0].style.zIndex = '9'
            this.$store.commit('modalStatus/set_modal_mode', true)
            if(type == 'refund'){
                this.$store.dispatch('setModalStatus', {state: true, type: 'refundDetail'})
            }else if(type == 'ledger') {
                this.$store.dispatch('setModalStatus', {state: true, type: 'ledgerDetail'})
            }else if(type == 'taskDetail') {
                this.taskSeq = data
                this.$store.dispatch('setModalStatus', {state: true, type: 'taskDetail'})
            }
        },
        setBillDetail: function (billCid) {
            this.$analytics.logEvent('帳單明細', { screen_name: '帳單明細'})
            this.billId = billCid
            this.$store.dispatch('setModalStatus', {state: true, type: 'billDetail'})
            this.$store.commit('modalStatus/set_modal_mode', true)
            document.getElementsByClassName('financial-management-default')[0].style.zIndex = '9'
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
        // transSource: function (value) {
        //     if( value == 'BOOKING_DEPOSIT' ){
        //         return '訂金'
        //     }else if( value == 'CONTRACT_DEPOSIT' ) {
        //         return '押金'
        //     }else if( value == 'CONTRACT_BILL' ) {
        //         return '帳單'
        //     }else if( value == 'HOUSE_TASK_BONUS' ) {
        //         return '委託獎金'
        //     }else if(value == 'HOUSE_LEDGER'){
        //         return '記帳'
        //     }else if(value == 'RETURN_PAID_HOUSE_TASK_BONUS'){
        //         return '委託退款'
        //     }else if(value == 'BOOKING_DEPOSIT_FOR_TENANT_REJECT'){
        //         return '取消預定'
        //     }
        // },
        // transType: function (value) {
        //     if( value == 'INCOME' ){
        //         return '收入'
        //     }else if( value == 'EXPENSE' ) {
        //         return '支出'
        //     }
        // },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
     
    },
    computed: {
        fileterByHouse: function () {
            return this.incomeAndExpenditure.filter((item) => {
                if(this.filterQuery.houseName){
                    if(item.houseName == this.filterQuery.houseName){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        fileterBySource: function () {
            return this.fileterByHouse.filter((item) => {
                if(this.filterQuery.source){
                    if(item.source == this.filterQuery.source){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        fileterByType: function () {
            return this.fileterBySource.filter((item) => {
                if(this.filterQuery.type){
                    if(item.type == this.filterQuery.type){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByAmount: function () {
            return this.fileterByType.filter((item) => {
                if( this.filterQuery.amount ){
                    if( this.filterQuery.amount[0] <= item.amount && this.filterQuery.amount[1] >= item.amount ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByWord: function () {
            return this.filterByAmount.filter((item) => {
                if( this.filterWord ){
                    if( item.houseName.includes(this.filterWord) || item.address.includes(this.filterWord) ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            incomeAndExpenditure: 'GET_INCOME_EXPENDITURE_MGT_LIST',
            filterQuery: 'GET_INCOME_EXPENDITURE_MGT_FILTER_QUERY',
            filterWord: 'GET_INCOME_EXPENDITURE_MGT_FILTER_WORD',
        })
    },
    components: {
        'dot-dropmenu': DotDropMenu,
        AlartMsg,
        Modal,
        newBill,
        BillDetail,
        refundDetail,
        ledgerDetail,
        taskDetail
    }
}
</script>
<style lang="scss" scoped>
    .table-list.lease-done{
        // .table-list-title .house:before{
        //     content: '';
        //     position: absolute;
        //     width: 0;
        //     height: 0;
        //     left: 66px;
        //     top: 2px;
        //     border-style: solid;
        //     border-width: 0 2.5px 4px 2.5px;
        //     border-color: transparent transparent #525956 transparent;
        // }
        // .table-list-title .house:after{
        //     content: '';
        //     position: absolute;
        //     width: 0;
        //     height: 0;
        //     left: 66px;
        //     bottom: 1px;
        //     border-style: solid;
        //     border-width: 4px 2.5px 0 2.5px;
        //     border-color: #525956 transparent transparent transparent;
        // }
        .table-list-title .date,
        .table-list-body ul li .date{
            width: 90px;
            margin-right: 29px;
        }
        .table-list-title .house,
        .table-list-body ul li .house{
            position: relative;
            width: 200px;
            margin-right: 29px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
        }
        .table-list-title .address,
        .table-list-body ul li .address{
            width: 300px;
            margin-right: 29px;
        }
        .table-list-title .source,
        .table-list-body ul li .source{
            width: 146px;
            margin-right: 29px;
        }
        .table-list-body ul li .source{
            position: relative;
            display: flex;
            align-items: center;
            span:nth-child(2){
                position: relative;
                font-size: 12px;
                margin-left: 18px;
            }
            span:nth-child(2):before{
                content: "";
                position: absolute;
                height: 16px;
                width: 1px;
                background: #a8a5a4;
                top: -1px;
                left: -8px;
            }
        }
        .table-list-title .income,
        .table-list-body ul li .income{
            width: 28px;
            margin-right: 29px;
        }
        .table-list-title .amount,
        .table-list-body ul li .amount{
            width: 125px;
            margin-right: 29px;
            text-align: right;
        }
        // .table-list-body ul li .amount{
        //     text-align: right;
        // }
        .table-list-body ul li .amount.blue{
            color: #3942b5;
        }
        .table-list-body ul li .amount.red{
            color: #ff9275;
        }
    }
    @media screen and (max-width: 1280px){
        .table-list.lease-done{
            .table-list-title .date,
            .table-list-body ul li .date{
                margin-right: 33px;
            }
            .table-list-title .house,
            .table-list-body ul li .house{
                margin-right: 33px;
            }
            .table-list-title .address,
            .table-list-body ul li .address{
                margin-right: 33px;
            }
            .table-list-title .source,
            .table-list-body ul li .source{
                margin-right: 33px;
            }
            .table-list-title .income,
            .table-list-body ul li .income{
                margin-right: 33px;
            }
            .table-list-title .amount,
            .table-list-body ul li .amount{
                margin-right: 33px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/financialManagement/incomeAndExpenditure.vue